module.exports = __webpack_public_path__ + "static/media/progress.9b298e3a.svg";